module.exports = __webpack_public_path__ + "static/media/no-image-available.bf928d19.jpg";